import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
// import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box, Spacer, Modal } from '@eatclubcode/ec-component-library';
import { COLORS } from '../../ObeeTheme';
import { restaurantActivePropTypes } from '../../data/models/Restaurant';
import { SquareButton } from '../Button/SquareButton';
import Profile from './Profile';
import useStyles from './ProfileModalStyles';

const ProfileModal = ({ isOpen, onClose, restaurantActive }) => {
  const theme = useTheme();
  const classes = useStyles();

  /**
   * Update the profile settings
   * Happens on blur when editing
   */
  // const updateProfile = (fieldToUpdate, newValue) => {
  const updateProfile = () => {
    // uncomment when apis are done
    // if (isEmpty(restaurantActive.restaurant[fieldToUpdate]) && isEmpty(newValue)) {
    //   return;
    // }
    // if (restaurantActive.restaurant[fieldToUpdate] !== newValue) {
    //   saveRestaurant({ ...restaurantActive.restaurant, [fieldToUpdate]: newValue });
    // }
  };

  return (
    <Modal
      isOpen={isOpen}
      height='100%'
      fullWidth
      // title='Profile'
      inputStyle={{ top: 0, height: '100%' }}
      style={{
        container: { padding: '20px', height: 'auto', width: '100%', top: 0, color: 'green' },
        modal: { height: '100%' },
        content: { padding: '40px 32px 12px' },
        header: { padding: '20px 32px', background: COLORS.PALE_MINT },
      }}
      onClose={() => onClose()}
      showCloseText={false}
      headerLabel={
        <Box style={{ width: '100%' }}>
          <Spacer gap='m' style={{ alignItems: 'center' }}>
            <Box className={classes.logoContainer}>
              {/* <LogoSVG style={{ flexShrink: 0, height: '29px', width: '29px' }} /> */}
              {restaurantActive.restaurant.name?.[0]}
            </Box>
            <Spacer direction='vertical' gap={12}>
              <Box className={classes.restaurantName}>{restaurantActive.restaurant.name}</Box>
              <Box className={classes.restaurantAddress}>
                {restaurantActive.restaurant.address1}
              </Box>
            </Spacer>
          </Spacer>
        </Box>
      }
    >
      <Spacer direction='vertical' gap={24}>
        <Profile />
      </Spacer>
    </Modal>
  );
};

ProfileModal.defaultProps = {
  isOpen: false,
};

ProfileModal.propTypes = {
  restaurantActive: restaurantActivePropTypes.isRequired,
  // saveRestaurant: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  restaurantActive: state.restaurantActive,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      // saveRestaurant: saveRestaurantAction,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProfileModal);
